import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

export const RequestCreateAnonymousSuccess = withAsync({
    loader: lazyForPaint(
        () => import(/* webpackChunkName: "request-create-anonymous-success" */ './request-create-anonymous-success')
    ),
});
